/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UserDisableRequest = {
  properties: {
    id: {
      type: 'number',
      isRequired: true,
      format: 'int64',
    },
  },
} as const;
